import { api } from './client';

export type ReservaEstado = 'pendiente' | 'confirmada' | 'cumplida' | 'cancelada';

export interface Reservacion {
  id: number;
  sede_id: number;
  mesa_id: number | null;
  mesa_nombre?: string;
  mesa_capacidad?: number;
  cliente_nombre: string;
  cliente_telefono: string | null;
  personas: number;
  fecha_hora: string;
  estado: ReservaEstado;
  motivo: string | null;
  notas: string | null;
  creada_por: number | null;
  creada_por_nombre?: string;
  created_at: string;
}

export interface CrearReservaInput {
  sede_id: number;
  mesa_id?: number | null;
  cliente_nombre: string;
  cliente_telefono?: string;
  personas?: number;
  fecha_hora: string;
  motivo?: string;
  notas?: string;
}

export const listReservaciones = (opts: { sede_id?: number; estado?: ReservaEstado; desde?: string; hasta?: string; proximas?: boolean } = {}) => {
  const p = new URLSearchParams();
  Object.entries(opts).forEach(([k, v]) => v !== undefined && v !== null && v !== false && p.set(k, String(v)));
  const qs = p.toString();
  return api.get<Reservacion[]>(`/api/reservaciones${qs ? `?${qs}` : ''}`);
};

export const crearReservacion = (data: CrearReservaInput) =>
  api.post<Reservacion>('/api/reservaciones', data);

export const editarReservacion = (id: number, data: Partial<CrearReservaInput & { estado: ReservaEstado }>) =>
  api.patch<Reservacion>(`/api/reservaciones/${id}`, data);

export const cancelarReservacion = (id: number) =>
  api.del<{ ok: boolean }>(`/api/reservaciones/${id}`);
